import { useState } from 'react';
import { DEFAULT } from 'app/shared/models/Filter';
import isEqual from 'lodash/isEqual';

// Icons
import IconPayments from 'images/icons/payments.min.svg';
import IconBed from 'images/icons/bed.min.svg';

type InfoCardDetails = {
  title: string;
  description: string;
  icon: string;
};

type PriceState = {
  min: number;
  max: number;
};

type BedState = Array<number>;

type GetInfoCardTypeParams = {
  priceState: PriceState;
  bedState: BedState;
};

const INFO_CARD_MAP: Record<string, InfoCardDetails> = {
  price: {
    title: 'Name your price',
    description: 'Set your price range to only see the homes that fit your budget.',
    icon: IconPayments,
  },
  bedrooms: {
    title: 'Need more room?',
    description: 'Filter homes by the number of bedrooms you need.',
    icon: IconBed,
  },
};

export const useInfoCards = (): [(params: GetInfoCardTypeParams) => void, InfoCardDetails | null, boolean, boolean] => {
  const [shouldDisplayPriceSlider, setShouldDisplayPriceSlider] = useState(false);
  const [shouldDisplayBedSelector, setShouldDisplayBedSelector] = useState(false);
  const [infoCardDetails, setInfoCardDetails] = useState<InfoCardDetails | null>(null);

  const getInfoCardType = ({ priceState, bedState }: GetInfoCardTypeParams) => {
    if (priceState.max === DEFAULT.price.max && priceState.min === DEFAULT.price.min) {
      setShouldDisplayPriceSlider(true);
      setInfoCardDetails(INFO_CARD_MAP.price);
      return;
    } else if (isEqual(bedState, DEFAULT.bedrooms)) {
      setShouldDisplayBedSelector(true);
      setInfoCardDetails(INFO_CARD_MAP.bedrooms);
      return;
    } else {
      setShouldDisplayPriceSlider(false);
      setShouldDisplayBedSelector(false);
      setInfoCardDetails(null);
      return;
    }
  };

  return [getInfoCardType, infoCardDetails, shouldDisplayPriceSlider, shouldDisplayBedSelector];
};
